import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Container = styled("button")`
    position: fixed;
    top: -100px;
    width: 13.125rem;
    font-family: ${({theme}) => theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY};
    color: ${({theme}) => theme.uxfabric.text.primary};
    background: ${({theme}) => theme.uxfabric.background.paper};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonLarge.fontWeight};
    border: 0.125rem solid #1d89dd;
    height: 2.75rem;
    z-index: 10;
    padding-top: 0.625rem;
    transition: all 0.5s;
    text-align: center;

    &.focus-visible {
        top: 0;
    }
`
